import React, {useCallback, useEffect, useMemo, useState} from 'react';
import PropTypes from 'prop-types';

import LocalizationPicker from '@stubhub/react-localization-picker';
import {getSupportedCurrencies} from '@stubhub/react-store-default-currency';

import '../styles/index.scss';

const StoreConfigButton = ({
  enableLanguageSelector,
  enableCurrencySelector,
  selectedCurrency,
  selectedLanguage,
  onClose,
}) => {
  const [showLanguageSelectorModal, setShowLanguageSelectorModal] = useState(false);
  const [supportedCurrencies, setSupportedCurrencies] = useState([]);
  const isIE11Browser =
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    !!window.MSInputMethodContext &&
    !!document.documentMode;

  const onCloseLocalizationPicker = () => {
    setShowLanguageSelectorModal(false);
    onClose && onClose();
  };

  const buttonClickHandler = () => {
    setShowLanguageSelectorModal(true);
  };

  const loadSupportedCurrencies = useCallback(async () => {
    const supportedCurrencies = await getSupportedCurrencies();
    setSupportedCurrencies(supportedCurrencies);
  }, []);

  useEffect(() => {
    loadSupportedCurrencies();
  }, [loadSupportedCurrencies]);

  const getCurrency = useMemo(() => {
    if (supportedCurrencies?.length) {
      const isCurrencySupported = supportedCurrencies.some(({key}) => key === selectedCurrency);

      return isCurrencySupported && selectedCurrency;
    }

    return null;
  }, [supportedCurrencies, selectedCurrency]);

  return (
    !isIE11Browser && (
      <>
        <LocalizationPicker
          visible={showLanguageSelectorModal}
          onClose={onCloseLocalizationPicker}
          showLanguageSelector={enableLanguageSelector}
          showCurrencySelector={enableCurrencySelector}
        />
        <button type="button" onClick={buttonClickHandler} className="store-config-button">
          {enableCurrencySelector ? getCurrency || '$€¥' : selectedLanguage}
        </button>
      </>
    )
  );
};

StoreConfigButton.propTypes = {
  /**
   * If language selector should be shown or not in the modal
   */
  enableLanguageSelector: PropTypes.bool,

  /**
   * If currency selector should be shown or not in the modal
   */
  enableCurrencySelector: PropTypes.bool,

  /**
   * Currently selected currency
   */
  selectedCurrency: PropTypes.string,

  /**
   * Currently selected locale
   */
  selectedLanguage: PropTypes.string,

  /**
   * Function to invoke on modal close
   */
  onClose: PropTypes.func,
};

export default StoreConfigButton;
